export const LINK_NODE_TYPE = 'link'
